import { useTranslation } from "react-i18next"
import { useContextState } from "../../../../../hooks/theme"
import { Box, Icon, Tooltip, Typography } from "@mui/material"
import { icons } from "../../../../../utils/icons"

const useColumnTest = () => {
  const { t } = useTranslation()
  const { colors } = useContextState()
  const styles = {
    text: {
      color: colors.color13,
      fontSize: '12px',
      wordBreak: 'break-word',
      '&.title-table': {
        fontSize: '14px',
        fontWeight: 'bold'
      }
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      '& .w-full': {
        width: '100%'
      }
    },
    warning: {
      color: colors.color12
    },
    search: {
      color: '#000',
      opacity: '0.4'
    },
    icons: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      justifyContent: 'end',
      '& .greyColor': {
        color: colors.color10
      }
    },
    grey: {
      color: colors.color10,
      width: '100%'
    },
    containerFlex: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      '&.p-20': {
        padding: '20px'
      },
    },
    containerSearch: {
      background: colors.color5,
      '& .MuiTypography-root': {
        color: colors.color10
      },
      '& .bold': {
        fontSize: '18px',
        fontWeight: 'bold',
      },
      '&.p-20': {
        padding: '20px'
      },
      '& .p-20': {
        padding: '20px'
      },
      '& .px-20': {
        padding: '10px 20px'
      },
      '& .border-t': {
        borderTop: `1px solid ${colors.color10}`
      },
      '& .border-r': {
        borderRight: `1px solid ${colors.color10}`

      }
    }
  }
  return [
    {
      id: 'user',
      label: t('general.tags.user'),
      minWidth: 200,
      renderCell: (params: any) => {
        const row = params.row
        const { firstName, lastName, curp, gender } = row
        const isEmpty = !firstName && !lastName && !curp && !gender
        return (
          <Box sx={styles.container}>
            {
              isEmpty ? <Typography className='w-full' sx={styles.text}>N/A</Typography> : (
                <>
                  <Typography className='w-full' sx={styles.text}>{!firstName && !lastName ? 'N/A' : `${firstName ?? ''} ${lastName ?? ''}`}</Typography>

                  <Typography className='w-full' sx={styles.text}>CURP {curp} - {gender}</Typography>
                </>
              )
            }
          </Box>
        )
      }
    },
    {
      "id": "userTypeName",
      "label": t('general.tags.type'),
      minWidth: 120,
    },
    {
      "id": "roleName",
      "label": t('general.tags.role'),
      minWidth: 120,
    },
    {
      "id": "companyName",
      "label": t('general.tags.company'),
      minWidth: 120,
    },
    {
      "id": "storeName",
      "label": t('dashboard.data.unit'),
      minWidth: 120,
    },
    {
      "id": "questionnairesNames",
      "label": t('dashboard.data.questionnaire'),
      minWidth: 120,
    },
    {
      "id": "id",
      "label": 'Registro',
      minWidth: 120,
      renderCell: (params: any) => {
        return <Typography sx={styles.grey} variant='body2'>{params.current?.toString()?.includes('tmp-id') ? 'Nuevo' : 'Existe'}</Typography>
      }
    },
    {
      id: 'Errores',
      label: "",
      minWidth: 50,
      renderCell: (params: any) => {
        const row = params.row
        return (
          <Box sx={styles.icons}>
            {params.current && (
              <Tooltip
                componentsProps={{
                  tooltip: {
                    sx: {
                      '&.MuiTooltip-tooltip.MuiTooltip-tooltip': {
                        backgroundColor: `${colors.color5}`,
                        borderRadius: '8px',
                        overflow: 'hidden',
                        marginRight: '20px',
                        padding: '20px',
                        boxShadow: `0px 0px 2px ${colors.color10}`
                      }
                    }
                  }
                }}
                title={<Box sx={styles.containerFlex}>
                  {params.current?.split(',')?.map((item: string) => <Typography sx={styles.grey} variant='body2'>{item}</Typography>)}
                </Box>}
                children={<Icon sx={styles.warning}>{icons('warningFull')}</Icon>}
              />
            )}

            <Tooltip
              componentsProps={{
                tooltip: {
                  sx: {
                    '&.MuiTooltip-tooltip.MuiTooltip-tooltip': {
                      backgroundColor: `${colors.color5}`,
                      minWidth: '250px',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      marginRight: '20px',
                      padding: '0',
                      boxShadow: `0px 0px 2px ${colors.color10}`
                    }
                  }
                }
              }}
              title={
                <Box sx={styles.containerSearch} className="p-20">
                  {
                    !row.email && !row.phone ? (<Typography variant="body2">{'N/A'}</Typography>) :
                      (
                        <>

                          <Typography variant="body2">{row.email ?? 'N/A'}</Typography>

                          <Typography variant="body2">{row.phone ?? 'N/A'}</Typography>
                        </>
                      )
                  }
                </Box>
              }
              children={<Icon sx={styles.search}>{icons('search')}</Icon>}
            />
          </Box>
        )
      }
    },
  ]

}

export { useColumnTest }